// ** Imports
import * as React from 'react'
import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker, DateTimePicker, TimePicker } from '@mui/x-date-pickers'
import TextFieldError from './TextFieldError'
import { InputAdornment, Typography } from '@mui/material'
import { CalendarClock } from 'mdi-material-ui'
import { useState } from 'react'

interface DateRangeType {
  type: 'time' | 'date'
  value: Date | undefined | null
  setValue: (dateValue: any) => void
  label?: string
  errorMessage?: string
  errorStatus?: boolean
  handleFocus?: (e: any) => void
  iconComponent?: JSX.Element | undefined
}

const AdvanceDateTimeInput: React.FC<DateRangeType> = ({
  type,
  value,
  setValue,
  label,
  errorMessage,
  errorStatus,
  handleFocus,
  iconComponent
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'start',
        flexDirection: 'column'
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div>
          <Typography
            variant='body2'
            sx={{
              fontWeight: 500,
              fontSize: 12
            }}
          >
            {label}
          </Typography>
          {type === 'date' ? (
            <DatePicker
              value={value}
              open={isOpen}
              closeOnSelect={true}
              inputFormat='dd/MM/yyyy'
              onAccept={() => setIsOpen(false)}
              disablePast={true}
              onChange={newValue => {
                setValue(newValue)
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  className={'shadow-sm rounded-lg'}
                  error={errorStatus}
                  size='small'
                  margin='none'
                  onFocus={handleFocus}
                  onClick={() => setIsOpen(true)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position='end'
                        sx={{ cursor: 'pointer', m: 0, p: 0 }}
                        onClick={() => setIsOpen(!isOpen)}
                      >
                        {iconComponent}
                      </InputAdornment>
                    )
                  }}
                />
              )}
            />
          ) : (
            <TimePicker
              value={value}
              open={isOpen}
              closeOnSelect={true}
              onAccept={() => setIsOpen(false)}
              onChange={newValue => {
                setValue(newValue)
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  className={'shadow-sm rounded-lg'}
                  error={errorStatus}
                  size='small'
                  margin='none'
                  onClick={() => setIsOpen(true)}
                  onFocus={handleFocus}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position='end'
                        sx={{ cursor: 'pointer', m: 0, p: 0 }}
                        onClick={() => setIsOpen(!isOpen)}
                      >
                        {iconComponent}
                      </InputAdornment>
                    )
                  }}
                />
              )}
            />
          )}
          {errorStatus ? <TextFieldError message={errorMessage ?? ''} /> : <></>}
        </div>
      </LocalizationProvider>
    </div>
  )
}

export default AdvanceDateTimeInput
